import {Field} from 'formik';

function FormikCheckbox(props: ICheckbox) {
  return (
    <Field name={props.name}>
      {({field, form}) => {
        return (
          <>
            <label className=" text-gray-6 text-sm">
              <input
                {...field}
                type="checkbox"
                className="mx-2 mt-1"
                checked={field.value}
              />
              {props.value}
            </label>
            <>
              {Boolean(form.touched.name) && form.errors.name?.toString() && (
                <>
                  <div className="pt-1">
                    <small>
                      <i className="icon-warning"></i>{' '}
                      {form.errors.name?.toString()}
                    </small>
                  </div>
                </>
              )}
            </>
          </>
        );
      }}
    </Field>
  );
}
export default FormikCheckbox;
